import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "react-use";
import {
  CasinoMenuIcon,
  ChatIcon,
  HamburgerIcon,
  HeaderSearchIcon,
  SportsMenuIcon,
  StatisticsIcon,
  InfoNewIcon,
} from "components/ui-kit/Icons/svg/index";
import { ROUTE_PATHS } from "constants/index";
import {
  setShowChat,
  setShowNotification,
  setShowSearchPopup,
  toggleChat,
  toggleSearchPopup,
} from "redux-thunk/redux/slices/settings.slice";
import { setShowLoginPopup } from "redux-thunk/redux/slices/gameSetting.slice";

const ResponsiveButtonBar = ({ sidenavExpand }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const { showSideNav, showChat, showSearchPopup } = useSelector(
    (state) => state?.settings
  );
  const { loginData } = useSelector((state) => state.auth);
  // const { newAnnouncements } = useSelector(state => state.announcement)
  const { pathname } = useLocation();
  const history = useHistory();

  const handleMenuClick = () => {
    sidenavExpand();
    dispatch(setShowSearchPopup(false));
    if (width < 768) {
      showChat && dispatch(setShowChat(false));
    }
  };

  const handleSearchClick = useCallback(() => {
    dispatch(setShowChat(false));
    showSideNav && sidenavExpand();
    dispatch(toggleSearchPopup());
  }, [showSideNav]);

  const handleChatClick = useCallback(() => {
    dispatch(toggleChat());
    history.push(ROUTE_PATHS.CONTACT);
    dispatch(setShowNotification(false));
    dispatch(setShowSearchPopup(false));
    showSideNav && sidenavExpand();
  }, [showSideNav]);

  const handleClickPages = useCallback(
    (element) => {
      dispatch(setShowChat(false));
      dispatch(setShowSearchPopup(false));
      showSideNav && sidenavExpand();
      history.push(element.path);
    },
    [showSideNav]
  );

  const responsiveBarOptions = [
    {
      label: t("menu"),
      id: 1,
      path: pathname,
      iconComponent: HamburgerIcon,
      isSideNav: true,
      onClick: handleMenuClick,
    },
    {
      label: t("casino"),
      id: 2,
      path: ROUTE_PATHS.CASINO,
      iconComponent: CasinoMenuIcon,
      onClick: handleClickPages,
    },
    {
      label: t("sports"),
      id: 3,
      path: ROUTE_PATHS.SPORTS_BOOK,
      iconComponent: () => (
        <div className="menu-icon" style={{ transform: "scale(1.1)" }}>
          <SportsMenuIcon />
        </div>
      ),
      onClick: handleClickPages,
    },
    {
      label: "Polymarket",
      id: 4,
      path: ROUTE_PATHS.PREDICTION_MARKET,
      iconComponent: StatisticsIcon,
      onClick: handleClickPages,
    },
    {
      label: t("search"),
      id: 5,
      path: pathname,
      iconComponent: HeaderSearchIcon,
      isSearch: true,
      onClick: handleSearchClick,
    },
    {
      label: t("chat"),
      id: 6,
      path: ROUTE_PATHS.CONTACT,
      iconComponent: ChatIcon,
      isChat: true,
      onClick: handleChatClick,
    },
    {
      label: "Details",
      id: 7,
      path: ROUTE_PATHS.CRYPTO_ABT,
      iconComponent: InfoNewIcon,
      onClick: handleClickPages,
    },
  ];

  const handleActiveSate = (element) => {
    if ("isSideNav" in element) {
      return showSideNav ? "active" : "";
    }
    if ("isSearch" in element) {
      return showSearchPopup ? "active" : "";
    }
    if ("isChat" in element) {
      return showChat ? "active" : "";
    }
    // Handle prediction market path match
    if (element?.path === ROUTE_PATHS.PREDICTION_MARKET && pathname === ROUTE_PATHS.PREDICTION_MARKET) {
      return "active";
    }
    // Handle crypto-future path match
    if (element?.path === ROUTE_PATHS.CRYPTO_ABT && (pathname === ROUTE_PATHS.CRYPTO_ABT || pathname.startsWith(ROUTE_PATHS.CRYPTO))) {
      return "active";
    }
    return pathname === element.path ? "active" : "";
  };

  return (
    <div className="Mobile-bottom-bar d-block d-xl-none">
      <ul className="list-inline mb-0 d-flex justify-content-between overflow-auto flex-nowrap">
        {responsiveBarOptions.map((element) => (
          <li key={element.id} className="list-inline-item">
            <button
              type="button"
              onClick={() => element?.onClick(element)}
              className={`btn btn-primary justify-content-end ${handleActiveSate(
                element
              )}`}
            >
              <element.iconComponent />
              <span>{element.label}</span>
            </button>
          </li>
        ))}

        {/* //TODO UNCOMMENT WHEN NEED NOTIFICATION BUTTON */}
        {/* {loginData?.accessToken &&
          <li className='list-inline-item'>
            <button
              className='btn btn-primary'
              onClick={() => {
                dispatch(setShowChat(false))
                dispatch(setShowNotification(true))
              }}
            >
              {newAnnouncements &&
                <div className='chat-notification-icon' />}
              <ReawardIcon />
              <span>Rewards</span>
            </button>
          </li>} */}
        {/* {loginData?.accessToken && */}
      </ul>
    </div>
  );
};

export default ResponsiveButtonBar;
